import React from 'react';
import PropTypes from 'prop-types';

import { LAYER_SUBTYPES } from '../../../api/Layers/Layers';
import LayerWMSLayerNamesField from '../LayerWMSLayerNamesField';
import LayerWMSStyleNameField from '../LayerWMSStyleNameField';
import LayerWMSVersionField from '../LayerWMSVersionField';

const LayerWMSFields = ({ layerSubType, ...rest }) => {
  if (LAYER_SUBTYPES.WMS === layerSubType) {
    return (
      <>
        <LayerWMSLayerNamesField {...rest} />
        <LayerWMSStyleNameField {...rest} />
        <LayerWMSVersionField {...rest} />
      </>
    );
  }
  return '';
};

LayerWMSFields.propTypes = {
  layerSubType: PropTypes.string.isRequired
};

export default LayerWMSFields;
